
import {Authenticated, NotAuthenticated, UserAccsessList, isAdmin, isNotAdmin} from './AccountingActions'

const authInitState = {
    isAuthorize : false,
    AccessList: localStorage.getItem('accessList') !== null ? localStorage.getItem('accessList').split(','): [],
    isAdmin: false
}

export const handleAuth = (state = authInitState, action) =>{
    switch (action.type) {
        case Authenticated:
            return {...state, isAuthorize: true}
        case NotAuthenticated:
            return {...state, isAuthorize: false, AccessList: []}
        case isAdmin:
            return {...state, isAdmin: true, AccessList: []}
        case isNotAdmin:
            return {...state, isAdmin: false, AccessList: []}
        case UserAccsessList:
            return {...state, AccessList: action.data}
        default:
            return state
    }
}
